import React from "react"
import PropTypes from 'prop-types';
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Toggle extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      isChecked: false
    }

    this.config = { 
      types : [],
      modifiers : [ 
        {
          title: 'default',
          isDefault: true,
        },
        'inverse'
      ], 
      states : []
    }

    this.handleCheckBox = this.handleCheckBox.bind(this)
  }

  handleCheckBox(e) {
    let target = e.target
    this.props.onChange && this.props.onChange(e, target)
  }

  render() {
    const { id, value, disabled, checked, ...rest } = this.props
    const isChecked = checked
    return  <div id={this.props.parentId} className={resolveProps(this.props, this.config, 'Toggle') + ' ' + (this.props.parentClassName || '') }>
      <div className="mdn-Toggle-list">
        <input 
          {...rest}
          id={id} 
          className="mdn-Toggle-item mdn-Toggle-item-primary" 
          type="checkbox" 
          onChange={this.handleCheckBox} 
          value={value || isChecked}
          checked={isChecked}
          disabled={disabled}
        />
        <label className="mdn-Toggle-button" htmlFor={id} />
      </div>
    </div>
  }
}

Toggle.propTypes = {
  etc : PropTypes.object,
  disabled : PropTypes.bool,
  id : PropTypes.string,
  value : PropTypes.string
}